import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getInstructionUrl } from '@utils/getInstructionUrl';
import uniqueId from 'lodash.uniqueid';
import { planInfoMap } from '@const';
const iconDirectory = 'partners/icons';
const imgDirectory = 'partners/backgrounds';
export const pingoParentExternalLink = 'https://gdemoideti.onelink.me/BfYh/9o2m45vl';
export const leoniParentExternalLink = 'https://l.mts.ru/1/H2CIwp';
export const logicLikeParentExternalLink = 'https://rnlogicapp.page.link/junior';
export const pingoParent = {
    name: 'pingo',
    serviceName: 'servicePingo',
    id: uniqueId(),
    title: _jsx(_Fragment, { children: "\u0413\u0434\u0435 \u043C\u043E\u0438 \u0434\u0435\u0442\u0438" }),
    serviceTitle: _jsx(_Fragment, { children: "\u0413\u0434\u0435 \u043C\u043E\u0438 \u0434\u0435\u0442\u0438" }),
    icon: {
        mobile: { alt: 'pingo', src: { fileName: 'pingo.png', directory: iconDirectory } },
    },
    text: {
        mobile: _jsx(_Fragment, { children: "\u0413\u0435\u043E\u043B\u043E\u043A\u0430\u0446\u0438\u044F \u0440\u0435\u0431\u0451\u043D\u043A\u0430" }),
        desktop: _jsx(_Fragment, { children: "\u0413\u0435\u043E\u043B\u043E\u043A\u0430\u0446\u0438\u044F \u0438\u00A0\u0437\u0430\u0431\u043E\u0442\u0430 \u0434\u0430\u0436\u0435 \u043D\u0430\u00A0\u0440\u0430\u0441\u0441\u0442\u043E\u044F\u043D\u0438\u0438 " }),
    },
    price: '199 ₽',
    link: { href: getInstructionUrl('pingo', false) },
    img: {
        mobile: {
            alt: 'pingo',
            src: { fileName: 'pingo-bg-mobile.png', directory: imgDirectory },
        },
        desktop: { alt: 'pingo', src: { fileName: 'pingo-bg-desktop.png', directory: imgDirectory } },
    },
};
export const leoniParent = {
    name: 'leoni',
    serviceName: 'serviceLeoni',
    id: uniqueId(),
    title: _jsx(_Fragment, { children: "Leoni" }),
    serviceTitle: 'Leoni',
    icon: {
        mobile: { alt: 'leoni', src: { fileName: 'leoni.png', directory: iconDirectory } },
    },
    text: {
        mobile: (_jsxs(_Fragment, { children: ["\u0414\u0438\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0430 ", _jsx("br", {}), " \u0442\u0430\u043B\u0430\u043D\u0442\u043E\u0432 \u0440\u0435\u0431\u0451\u043D\u043A\u0430"] })),
        desktop: _jsx(_Fragment, { children: "\u0414\u0438\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0430 \u043D\u0430\u0432\u044B\u043A\u043E\u0432, \u0442\u0430\u043B\u0430\u043D\u0442\u043E\u0432 \u0440\u0435\u0431\u0451\u043D\u043A\u0430" }),
    },
    badge: {
        mobile: 'Бесплатно в годовой подписке',
        desktop: 'Только в годовой подписке',
    },
    price: '3990 ₽',
    link: { href: getInstructionUrl('leoni', false) },
    img: {
        mobile: {
            alt: 'leoni',
            src: { fileName: 'leoni-bg-mobile.png', directory: imgDirectory },
        },
        desktop: {
            alt: 'leoni',
            src: { fileName: 'leoni-bg-desktop.png', directory: imgDirectory },
        },
    },
};
export const logicLikeParent = {
    name: 'logicLike',
    serviceName: 'serviceLogicLike',
    id: uniqueId(),
    title: _jsx(_Fragment, { children: "\u041B\u043E\u0433\u0438\u043A\u041B\u0430\u0439\u043A" }),
    serviceTitle: 'ЛогикЛайк',
    icon: {
        mobile: { alt: 'logicLike', src: { fileName: 'logicLike.png', directory: iconDirectory } },
    },
    text: {
        mobile: _jsx(_Fragment, { children: "\u0420\u0430\u0437\u0432\u0438\u0432\u0430\u044E\u0449\u0438\u0435 \u0438\u0433\u0440\u044B" }),
        desktop: _jsx(_Fragment, { children: "\u041F\u043E\u043B\u0435\u0437\u043D\u044B\u0435 \u0438\u0433\u0440\u044B \u0434\u043B\u044F\u00A0\u0440\u0430\u0437\u0432\u0438\u0442\u0438\u044F" }),
    },
    price: '499 ₽',
    link: { href: getInstructionUrl('logicLike', false) },
    img: {
        mobile: {
            alt: 'logicLike',
            src: { fileName: 'logic-like-bg-mobile.png', directory: imgDirectory },
        },
        desktop: {
            alt: 'logicLike',
            src: { fileName: 'logic-like-bg-desktop.png', directory: imgDirectory },
        },
    },
};
export const kionParent = {
    name: 'kion',
    serviceName: 'serviceKion',
    id: uniqueId(),
    title: _jsx(_Fragment, { children: "KION" }),
    serviceTitle: 'KION',
    icon: {
        mobile: { alt: 'kion', src: { fileName: 'kion.png', directory: iconDirectory } },
    },
    text: {
        mobile: _jsx(_Fragment, { children: "\u041C\u0443\u043B\u044C\u0442\u0438\u043A\u0438 \u0438 \u0444\u0438\u043B\u044C\u043C\u044B" }),
        desktop: _jsx(_Fragment, { children: "\u041C\u0443\u043B\u044C\u0442\u0438\u043A\u0438, \u0444\u0438\u043B\u044C\u043C\u044B \u043F\u043E\u00A0\u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0443 \u0440\u0435\u0431\u0451\u043D\u043A\u0430" }),
    },
    price: '249 ₽',
    link: { href: getInstructionUrl('kion', false) },
    img: {
        mobile: {
            alt: 'kion',
            src: { fileName: 'kion-bg-mobile.png', directory: imgDirectory },
        },
        desktop: {
            alt: 'kion',
            src: { fileName: 'kion-bg-desktop.png', directory: imgDirectory },
        },
    },
};
export const musicParent = {
    name: 'music',
    serviceName: 'serviceMusic',
    id: uniqueId(),
    title: _jsx(_Fragment, { children: "\u041C\u0422\u0421 \u041C\u0443\u0437\u044B\u043A\u0430" }),
    serviceTitle: 'МТС Музыка',
    icon: {
        mobile: { alt: 'music', src: { fileName: 'music.png', directory: iconDirectory } },
    },
    text: {
        mobile: _jsx(_Fragment, { children: "\u0421\u043A\u0430\u0437\u043A\u0438 \u0438\u00A0\u043C\u0443\u0437\u044B\u043A\u0430" }),
        desktop: _jsx(_Fragment, { children: "\u0421\u043A\u0430\u0437\u043A\u0438 \u0438\u00A0\u043C\u0443\u0437\u044B\u043A\u0430 \u0431\u0435\u0437\u00A0\u043F\u043B\u043E\u0445\u0438\u0445 \u0441\u043B\u043E\u0432" }),
    },
    price: '169 ₽',
    link: { href: getInstructionUrl('music', false) },
    img: {
        mobile: {
            alt: 'music',
            src: { fileName: 'music-bg-mobile.png', directory: imgDirectory },
        },
        desktop: {
            alt: 'music',
            src: { fileName: 'music-bg-desktop.png', directory: imgDirectory },
        },
    },
};
export const launcherParent = {
    name: 'launcher',
    id: uniqueId(),
    serviceName: 'serviceLauncher',
    title: _jsx(_Fragment, { children: "\u041C\u0422\u0421\u00A0\u041B\u043E\u043D\u0447\u0435\u0440 Junior" }),
    serviceTitle: 'МТС Лончер Junior',
    icon: {
        mobile: {
            alt: 'launcher',
            src: { fileName: 'launcher.png', directory: iconDirectory },
        },
    },
    text: {
        mobile: _jsx(_Fragment, { children: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0440\u0435\u0431\u0451\u043D\u043A\u0443 \u0432\u0441\u0435\u00A0\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0440\u0430\u0437\u043E\u043C c\u00A0\u041C\u0422\u0421\u00A0\u041B\u043E\u043D\u0447\u0435\u0440 Junior \u043D\u0430 Android" }),
        desktop: _jsx(_Fragment, { children: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0430 \u0432\u0441\u0435\u0445 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0438" }),
    },
    note: 'Только для Android',
    link: {
        href: 'https://play.google.com/store/apps/details?id=ru.mts.launcher.kid&utm_source=juniorru&utm_medium=card_launcher_j&utm_campaign=mts_junior&utm_content=parent&utm_term=launcher_j',
        isExternal: true,
    },
    img: {
        mobile: {
            alt: 'launcher',
            src: { fileName: 'launcher-bg-mobile.png', directory: imgDirectory },
        },
        desktop: {
            alt: 'launcher',
            src: { fileName: 'launcher-bg-desktop.png', directory: imgDirectory },
        },
    },
};
const kionChild = {
    ...kionParent,
    link: {
        href: getInstructionUrl('kion', true),
    },
    text: { mobile: _jsx(_Fragment, { children: "\u0421\u043C\u043E\u0442\u0440\u0438 \u043C\u0443\u043B\u044C\u0442\u0438\u043A\u0438 \u0438\u00A0\u0430\u043D\u0438\u043C\u0435 \u0432\u00A0KION" }), desktop: _jsx(_Fragment, { children: "\u0421\u043C\u043E\u0442\u0440\u0438 \u043C\u0443\u043B\u044C\u0442\u0438\u043A\u0438 \u0438\u00A0\u0430\u043D\u0438\u043C\u0435" }) },
};
const logicLikeChild = {
    ...logicLikeParent,
    link: { href: getInstructionUrl('logicLike', true) },
    text: { mobile: _jsx(_Fragment, { children: "\u0421\u043E\u0440\u0435\u0432\u043D\u0443\u0439\u0441\u044F \u0441\u00A0\u0434\u0440\u0443\u0437\u044C\u044F\u043C\u0438 \u0432\u00A0\u041B\u043E\u0433\u0438\u043A\u041B\u0430\u0439\u043A" }), desktop: _jsx(_Fragment, { children: "\u0421\u043E\u0440\u0435\u0432\u043D\u0443\u0439\u0441\u044F \u0441\u00A0\u0434\u0440\u0443\u0437\u044C\u044F\u043C\u0438" }) },
};
const musicChild = {
    ...musicParent,
    link: { href: getInstructionUrl('music', true) },
    text: { mobile: _jsx(_Fragment, { children: "\u0421\u043B\u0443\u0448\u0430\u0439 \u043F\u0435\u0441\u043D\u0438, \u043F\u043E\u0434\u043A\u0430\u0441\u0442\u044B \u0438\u00A0\u0441\u043A\u0430\u0437\u043A\u0438 \u0432\u00A0\u041C\u0422\u0421 \u041C\u0443\u0437\u044B\u043A\u0435" }), desktop: _jsx(_Fragment, { children: "\u0421\u043B\u0443\u0448\u0430\u0439 \u043F\u0435\u0441\u043D\u0438, \u043F\u043E\u0434\u043A\u0430\u0441\u0442\u044B \u0438\u00A0\u0441\u043A\u0430\u0437\u043A\u0438" }) },
};
// const launcherChild: PartnersCard = {
//   ...launcherParent,
//   link: {
//     ...launcherParent.link,
//     href: 'https://play.google.com/store/apps/details?id=ru.mts.launcher.kid&utm_source=juniorru&utm_medium=card_launcher_j&utm_campaign=mts_junior&utm_content=child&utm_term=launcher_j',
//   },
//   text: {
//     mobile: <>Преобрази смартфон с МТС Лончер Junior на Android</>,
//     desktop: (
//       <>
//         Преобрази <br /> смартфон
//       </>
//     ),
//   },
// };
// список карточек с подзаголовком "Родителю" в род. версии
export const partnersForParent = [pingoParent, leoniParent];
// список карточек с подзаголовком "Ребенку" в род. версии
export const partnersForChild = [logicLikeParent, kionParent, musicParent];
// список карточек в дет. версии (без подписки)
export const partnersChildVersion = [
    {
        ...kionChild,
        text: { mobile: _jsx(_Fragment, { children: "\u041B\u044E\u0431\u0438\u043C\u044B\u0435 \u043C\u0443\u043B\u044C\u0442\u0438\u043A\u0438 \u0438\u00A0\u0430\u043D\u0438\u043C\u0435 \u0432\u00A0\u041A\u0438\u043E\u043D" }), desktop: _jsx(_Fragment, { children: "\u041B\u044E\u0431\u0438\u043C\u044B\u0435 \u043C\u0443\u043B\u044C\u0442\u0438\u043A\u0438 \u0438\u00A0\u0430\u043D\u0438\u043C\u0435" }) },
    },
    {
        ...logicLikeChild,
        text: { mobile: _jsx(_Fragment, { children: "\u0418\u0433\u0440\u044B \u0438\u00A0\u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0438 \u0441\u00A0\u041B\u043E\u0433\u0438\u043A\u041B\u0430\u0439\u043A" }), desktop: _jsx(_Fragment, { children: "\u0418\u0433\u0440\u044B, \u0437\u0432\u0451\u0437\u0434\u044B \u0438\u00A0\u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0438" }) },
    },
    {
        ...musicChild,
        text: { mobile: _jsx(_Fragment, { children: "\u0412\u043E\u043B\u0448\u0435\u0431\u043D\u044B\u0435 \u0441\u043A\u0430\u0437\u043A\u0438 \u0438\u00A0\u043C\u0443\u0437\u044B\u043A\u0430 \u0432\u00A0\u041C\u0422\u0421\u00A0\u041C\u0443\u0437\u044B\u043A\u0430" }), desktop: _jsx(_Fragment, { children: "\u0412\u043E\u043B\u0448\u0435\u0431\u043D\u044B\u0435 \u0441\u043A\u0430\u0437\u043A\u0438 \u0438\u00A0\u043C\u0443\u0437\u044B\u043A\u0430" }) },
    },
    // {
    //   ...launcherChild,
    //   text: {
    //     mobile: <>Одёжка для cмартфона c МТС Лончер Junior на Android</>,
    //     desktop: <>Одёжка для cмартфона</>,
    //   },
    // },
];
// список карточек в дет. версии (с подпиской)
export const partnersChildVersionSubscription = [kionChild, logicLikeChild, musicChild];
export const partnersBlockConfig = {
    parent: plan => ({
        title: _jsx(_Fragment, { children: "\u041F\u043E\u043B\u0435\u0437\u043D\u044B\u0435 \u0434\u0435\u0442\u0441\u043A\u0438\u0435 \u0441\u0435\u0440\u0432\u0438\u0441\u044B" }),
        promoText: (_jsxs(_Fragment, { children: ["\u0414\u043B\u044F \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432 \u043B\u044E\u0431\u044B\u0445 \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u043E\u0432 \u0441\u00A0\u0432\u044B\u0433\u043E\u0434\u043E\u0439 \u043E\u0442\u00A0", _jsx("b", { children: planInfoMap[plan].benefit })] })),
    }),
    child: () => ({
        title: 'Что в подписке',
        promoText: _jsx(_Fragment, { children: "\u0410\u043D\u0438\u043C\u0435 \u0438\u00A0\u043F\u043E\u0434\u043A\u0430\u0441\u0442\u044B, \u0438\u0433\u0440\u044B \u0438\u00A0\u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0438 \u0432\u00A0\u041B\u043E\u0433\u0438\u043A\u041B\u0430\u0439\u043A, \u0441\u0442\u0440\u0438\u043C\u044B \u0438\u00A0\u0447\u0430\u0442\u044B \u0441\u00A0\u043D\u0435\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043D\u044B\u043C \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043E\u043C" }),
    }),
};
